module.exports = __webpack_public_path__ + "static/media/palomino-8.14266746.jpg";